import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import Modal from 'util/modules/Modal'

import './styles/SystemDeprecationNotice.scss'

const STORAGE_KEY = '@App:SystemDeprecationNoticeAcceptedDate:2026-07-06'
const REGISTER_URL = 'https://console.underchat.com.br/register'
const WHATSAPP_URL = 'https://wa.me/5562999566428'
const DEPRECATION_DATE = '06/07/2026'

function getTodayKey (): string {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const SystemDeprecationNotice: React.FC = () => {
  const location = useLocation()

  const [isOpen, setIsOpen] = useState(false)
  const [hasAccepted, setHasAccepted] = useState(false)

  useEffect(() => {
    const isQrCodePage = location.pathname.startsWith('/channel/qr-code')
    if (isQrCodePage) {
      setIsOpen(false)
      return
    }

    const alreadyAcceptedToday = localStorage.getItem(STORAGE_KEY) === getTodayKey()
    setHasAccepted(false)
    setIsOpen(!alreadyAcceptedToday)
  }, [location.pathname])

  function handleAccept (): void {
    if (!hasAccepted) return

    localStorage.setItem(STORAGE_KEY, getTodayKey())
    setIsOpen(false)
  }

  return (
    <Modal isOpen={isOpen} className="system-deprecation-notice-modal">
      <div className="panel bordered system-deprecation-notice">
        <div className="row panel-header">
          <div className="grow">
            <p><i className="fa fa-exclamation-triangle" /> Aviso importante</p>
          </div>
        </div>

        <div className="panel-body">
          <p>
            <strong>Nova versao do UnderChat</strong>
          </p>

          <p>
            O UnderChat evoluiu e entrou oficialmente em uma nova fase.
          </p>

          <p>
            Reestruturamos a plataforma do zero, corrigimos limitacoes da versao
            {' '}
            anterior e adicionamos recursos que tornam o atendimento mais rapido,
            {' '}
            organizado e profissional.
          </p>

          <p>
            A versao atual sera descontinuada em <strong>{DEPRECATION_DATE}</strong>.
            {' '}
            Se voce ja utilizava o sistema, queremos que conheca essa nova
            {' '}
            experiencia.
          </p>

          <p>
            Acesse e crie sua conta na nova plataforma:
          </p>

          <a
            className="button system-deprecation-notice-link"
            href={REGISTER_URL}
            target="_blank"
            rel="noreferrer"
          >
            Ir para o novo cadastro
          </a>

          <a
            className="system-deprecation-notice-help-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
          >
            Duvidas? Clique aqui
          </a>

          <label className="system-deprecation-notice-checkbox">
            <input
              type="checkbox"
              checked={hasAccepted}
              onChange={(event): void => setHasAccepted(event.target.checked)}
            />
            <span>
              Li o aviso, entendi a descontinuacao prevista para 06/07/2026 e
              {' '}
              estou ciente de que este aceite sera solicitado novamente no
              {' '}
              primeiro acesso de cada dia.
            </span>
          </label>

          <button
            className="button system-deprecation-notice-button"
            disabled={!hasAccepted}
            onClick={handleAccept}
            type="button"
          >
            Confirmar ciencia
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default SystemDeprecationNotice
